import { Logo } from "../../components/shared";
import { useAuth } from "../../context/AuthContext";

export default function ExpertPending() {
  const { logout } = useAuth();

  return (
    <main className="min-h-screen bg-slate-50 p-8">
      <section
        className="mx-auto max-w-lg border bg-white p-8"
        data-testid="expert-pending-page"
      >
        <Logo />
        <p className="mt-8 text-xs font-bold uppercase text-amber-700">
          Application submitted
        </p>
        <h1 className="mt-2 font-display text-3xl font-bold">
          Your Expert application is under review
        </h1>
        <p className="mt-4 text-sm text-slate-600">
          Your application is safely recorded. You will receive a secure activation invitation
          after approval.
        </p>
        <button
          className="mt-6 block text-sm text-amber-800"
          data-testid="expert-pending-sign-out"
          onClick={logout}
          type="button"
        >
          Sign out and return home
        </button>
      </section>
    </main>
  );
}